import { CommandActionAsync } from "src/app/abstract/command/command-action-async.service";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";
import { CloneService } from "../clone/clone.service";
import { WidgetsService } from "../widgets/widgets.service";
import { Logger } from "src/app/core/logger";
import { WidgetsMetadataService } from "../widgets/widgets-metadata.service";

@Injectable()
export class CommandUpdateNodeService extends CommandActionAsync {
    constructor(private widgetsCloneService: CloneService,
        private widgetsService: WidgetsService,    
        private widgetsMetadataService: WidgetsMetadataService,
        private logger:Logger) {
        super();
    }

    /**
     * Update a node with the provided value
     * @param origin In this case no parent is needed
     * @param destination The node to be updated. The uuid will have to exist previously
     * @returns 
     */
    public async executeAsync(parent:WidgetsAbstract, destination: WidgetsAbstract): Promise<WidgetsAbstract|undefined> {
        let foundNode = undefined;

        // Update the existing node with the new values
        if (parent && destination) {
            const foundNode = await this.widgetsService.updateNodeAsync(parent, destination);
            if (foundNode)
                return foundNode;
            else
                throw new Error("Node to replace not found.");            
        }
        throw new Error("Parent or Node are null/undefined. Can't replace.");
    }
}
